import { CodatState } from "../../stores/ui/ui-state"
import { ADFState } from "../../stores/user/user-state"

export function shouldShowDisclaimer(platform: CodatState, adfState: ADFState, legalDisclaimerAccepted: boolean, acceptedConsent: boolean): boolean {
  const codatRedirect = platform?.integration === "codat"
  const acceptedInPreviousSession = !!adfState?.codat_company_id
 
  if (codatRedirect || acceptedInPreviousSession) {
    return false
  } else {
    return !legalDisclaimerAccepted && !acceptedConsent
  }
}